import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { EMPTY, Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { Util } from './../_classes/util';
import { Retorno } from '../_classes/retorno';

import { SnackBarService } from './../_servicos/snack-bar.service';

import { FrqDia } from '../_classes/frq-dia';
import { Comprovante } from '../_classes/comprovante-ponto';
import { EnvService } from '../_servicos/env.service';
import { PontoService } from '../_servicos/ponto.service';
import { Servidor } from '../_classes/servidor';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TableUtils } from '../shared/table-utils';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-ponto-frequencia',
  templateUrl: './ponto-frequencia.component.html',
  styleUrls: ['./ponto-frequencia.component.scss'],
})
export class PontoFrequenciaComponent {
  @Input() servidor: Servidor;

  @ViewChild('template', { read: TemplateRef, static: true })
  template: TemplateRef<any>;

  config = {
    keyboard: true,
    class: 'modal-lg',
  };

  meses = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ];

  lista: FrqDia[];
  dataSource: MatTableDataSource<FrqDia>;
  //dataSource$: Observable<Retorno[]>;
  modalRef: BsModalRef;
  displayedColumns: string[] = [
    'dt',
    'marcacao',
    'jornada',
    'total',
    'minutos',
  ];

  erros$ = new Subject<boolean>();
  erro: string = '';
  carregandoErros: boolean = false;

  mes: number = 0;
  ano: number = 0;
  totalGeralMinutosMarcados = 0;
  totalMinutosJornada = 0;
  exibiuImpares: boolean = false;
  exibiuCorte: boolean = false;
  //exibiuCalculadoSim: boolean = false;
  //exibiuCalculadoNao: boolean = false;
  exibiuNaoHomologado: boolean = false;
  exibiuComprovanteNaoPDF: boolean = false;
  exibiuComprovantePDF: boolean = false;
  exibiuComputadoNao: boolean = false;
  exibiuComputado: boolean = false;

  carregando: boolean = false;

  mesExtenso = '';
  arquivoUrl: any;

  private t: any;

  constructor(
    private sanitizer: DomSanitizer,
    private _env: EnvService,
    private _ts: Title,
    private readonly _sP: PontoService,
    private _sM: BsModalService,
    private _snack: SnackBarService
  ) {
    this._ts.setTitle(_env.nome + ' - ' + _env.descricao);
    //this.dataSource$ = new Observable<Retorno[]>();
    //this.dataSource = new MatTableDataSource<FrqDia>();
    this.dataSource = null;
    this.totalGeralMinutosMarcados = 0;
    this.totalMinutosJornada = 0;
    this.exibiuImpares = false;
    this.exibiuCorte = false;
    //this.exibiuCalculadoSim = false;
    //this.exibiuCalculadoNao = false;
    this.exibiuNaoHomologado = false;
    this.exibiuComprovanteNaoPDF = false;
    this.exibiuComprovantePDF = false;
    this.carregando = false;
  }

  qualClasseMostrar(r: FrqDia, tipo: string) {
    let classe: string = 'NORMAL';
    if (r.feriado) {
      if (r.tipoFeriado === 'FDS') {
        classe = 'FDS';
      } else if (r.feriado.toUpperCase().includes('RECESSO')) {
        classe = 'RECESSO';
      } else {
        classe = 'FERIADO';
      }
    }

    if (
      classe === 'NORMAL' &&
      (!r.listaMarcacao || r.listaMarcacao.length < 2)
    ) {
      classe = 'FALTA';
    }
    return tipo + '-' + classe;
  }

  exportarExcel() {
    console.log('exportarExcel');
    let dias = [];
    //let dts: any = new MatTableDataSource<FrqDia>(this.dataSource.filteredData);

    this.dataSource.filteredData.forEach((item) => {
      let i = {
        dia: item.feriado,
        tipo: item.tipoFeriado,
        data: this.formatarData(item.dt),
        minutosJornada: item.totalMinutosJornada,
        minutosPonto: item.totalMinutosPonto,
        tx: item.txHorario,
        inAbonoAtraso: item.inAbonoAtraso,
        marcacao1: this.retornarMarcacaoOuNulo(item.listaMarcacao, 0),
        marcacao2: this.retornarMarcacaoOuNulo(item.listaMarcacao, 1),
        marcacao3: this.retornarMarcacaoOuNulo(item.listaMarcacao, 2),
        marcacao4: this.retornarMarcacaoOuNulo(item.listaMarcacao, 3),
        marcacao5: this.retornarMarcacaoOuNulo(item.listaMarcacao, 4),
        marcacao6: this.retornarMarcacaoOuNulo(item.listaMarcacao, 5),
        marcacao7: this.retornarMarcacaoOuNulo(item.listaMarcacao, 6),
        marcacao8: this.retornarMarcacaoOuNulo(item.listaMarcacao, 7),
        marcacao9: this.retornarMarcacaoOuNulo(item.listaMarcacao, 8),
        marcacao10: this.retornarMarcacaoOuNulo(item.listaMarcacao, 9),
        marcacaoW1: this.retornarMarcacaoOuNulo(item.listaMarcacaoWeb, 0),
        marcacaoW2: this.retornarMarcacaoOuNulo(item.listaMarcacaoWeb, 1),
        marcacaoW3: this.retornarMarcacaoOuNulo(item.listaMarcacaoWeb, 2),
        marcacaoW4: this.retornarMarcacaoOuNulo(item.listaMarcacaoWeb, 3),
        marcacaoW5: this.retornarMarcacaoOuNulo(item.listaMarcacaoWeb, 4),
        marcacaoW6: this.retornarMarcacaoOuNulo(item.listaMarcacaoWeb, 5),
        marcacaoW7: this.retornarMarcacaoOuNulo(item.listaMarcacaoWeb, 6),
        marcacaoW8: this.retornarMarcacaoOuNulo(item.listaMarcacaoWeb, 7),
        marcacaoW9: this.retornarMarcacaoOuNulo(item.listaMarcacaoWeb, 8),
        marcacaoW10: this.retornarMarcacaoOuNulo(item.listaMarcacaoWeb, 9),
      };
      dias.push(i);
    });
    let dts: any = new MatTableDataSource<FrqDia>(dias);
    TableUtils.exportArrayToExcel(dts.filteredData, 'Planilha1');
  }

  exportarPDF() {
    const doc = new jsPDF();
    // It can parse html:
    // <table id="my-table"><!-- ... --></table>
    autoTable(doc, { html: '#tabela' });
    doc.save('table.pdf');
  }
  /*
  mostrarCalculadoSim(i: any): boolean {
    if (i) {
      this.exibiuCalculadoSim = true;
    }
    return i ? true : false;
  }

  mostrarCalculadoNao(i: any): boolean {
    if (i) {
      this.exibiuCalculadoNao = true;
    }
    return i ? true : false;
  }*/

  retornarMarcacaoOuNulo(lista: any[], i: number) {
    if (lista) {
      //console.log('retornará', lista[i], lista[i] ? 'LST' : 'NL');
      return lista[i] ? lista[i].marcacao : null;
    } else {
      //console.log('retornará null');
      return null;
    }
  }

  qualLegendaMostrar(r: FrqDia) {
    let classe: string = '';
    if (r.feriado) {
      if (r.tipoFeriado === 'FDS') {
        classe = 'Final de Semana';
      } else {
        classe = 'Feriado';
      }
    } else {
      classe = 'Normal';
    }
    if (classe === 'Normal' && r.listaMarcacao && r.listaMarcacao.length < 2) {
      classe = 'Falta';
    }
    return classe;
  }

  ngOnDestroy(): void {
    if (this.t) {
      this.t.unsubscribe();
      this.carregando = false;
    }
  }

  mostrarSubTotal(r: FrqDia) {
    return !r.feriado;
  }

  computadoPeloSigep(r: FrqDia): boolean {
    if (r.inAbonoAtraso == 'S') {
      return true;
    } else {
      return r.totalMinutosMarcados ? true : false;
    }
  }

  minutosASeremMostrados(r: FrqDia): number {
    let qtde: number = 0;

    if (r.inAbonoAtraso == 'S') {
      //   console.log('é abono, total jornada:', r.totalMinutosJornada);
      qtde = r.totalMinutosJornada;
    } else {
      qtde =
        r.totalMinutosMarcados > 0
          ? r.totalMinutosMarcados
          : r.totalMinutosPonto;
    }

    return qtde;
  }

  executarAoMostrarOuDownloadBlob(
    x: Blob,
    baixar: boolean,
    nomeDoArquivo: string
  ) {
    //console.log('kk-executarAoMostrarOuDownloadBlob(x)', x, nomeDoArquivo);
    const blob = new Blob([Util.Base64ToBlob(x)], {
      type: 'application/pdf',
    });
    this.arquivoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );

    if (!baixar) {
      this.modalRef = this._sM.show(this.template, this.config);
    } else {
      let newVariable: any = window.navigator;
      if (newVariable && newVariable.msSaveOrOpenBlob) {
        newVariable.msSaveOrOpenBlob(blob); //console.log('Carregando aterado2', this.carregando);
        return;
      }
      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(blob);

      let link = document.createElement('a');
      link.href = data;
      link.download = nomeDoArquivo;
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );

      setTimeout(function (this: PontoFrequenciaComponent) {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        this.carregando = false;
      }, 100);
    }
    this.carregando = false;
  }

  qualClasseMostrar2(r: FrqDia, tipo: string) {
    let classe: string = '';
    if (
      r.tipoFeriado &&
      r.tipoFeriado != 'FDS' &&
      r.tipoFeriado != 'AFASTAMENTO' &&
      r.tipoFeriado != 'RECESSO'
    ) {
      classe = 'FERIADO';
    } else {
      classe = r.tipoFeriado ? r.tipoFeriado : 'NORMAL';
    }

    if (!r.tipoFeriado) {
      classe =
        (r.listaMarcacao ? r.listaMarcacao.length : 0) +
          (r.listaMarcacaoWeb ? r.listaMarcacaoWeb.length : 0) ==
        0
          ? r.inAbonoAtraso == 'S'
            ? 'AFASTAMENTO'
            : 'FALTA'
          : classe;
    }

    return tipo + '-' + classe;
  }

  qualClasseMostrar3(r: FrqDia, tipo: string) {
    let c = this.qualClasseMostrar2(r, tipo);

    //console.log(this.formatarData(r.dt), r.tipoFeriado, c);
    return c;
  }

  baixarComprovante(id: number) {
    this.carregando = true;
    if (this.servidor) {
      this._sP.getComprovantePonto(id).subscribe((a: Comprovante) => {
        this.executarAoMostrarOuDownloadBlob(
          a.bbComprovante,
          true,
          'Comprovante.pdf'
        );
      });
    }
  }

  ehHoje(d1: any): boolean {
    const dataX = new Date(d1);
    const dataAtual = new Date();

    // Extrai o dia, mês e ano da dataX
    const diaDataX = dataX.getDate();
    const mesDataX = dataX.getMonth();
    const anoDataX = dataX.getFullYear();

    // Extrai o dia, mês e ano da data atual
    const diaAtual = dataAtual.getDate();
    const mesAtual = dataAtual.getMonth();
    const anoAtual = dataAtual.getFullYear();

    return (
      anoDataX === anoAtual && mesDataX === mesAtual && diaDataX === diaAtual
    );
  }

  executarAoCarregarDatasource(x: FrqDia[]) {
    this.totalGeralMinutosMarcados = 0;
    this.totalMinutosJornada = 0;
    this.exibiuImpares = false;
    this.exibiuCorte = false;
    //this.exibiuCalculadoSim = false;
    //this.exibiuCalculadoNao = false;
    this.exibiuNaoHomologado = false;
    this.exibiuComprovanteNaoPDF = false;
    this.exibiuComprovantePDF = false;
    this.exibiuComputadoNao = false;
    this.exibiuComputado = false;

    this.dataSource = new MatTableDataSource<FrqDia>(x);

    //   console.log('executarAoCarregarDatasource', this.meses, this.mes, this.ano);
    //this.mesExtenso = this.meses[this.mes] + '/' + this.ano;
    let teste = x.reduce((acc, item) => {
      if (
        this.computadoPeloSigep(item)
        /*!(item.txHorario &&
          item.totalMinutosJornada !== 0 &&
          item.totalMinutosMarcados == 0) &&
        !item.feriado*/
      ) {
        acc++;
      }

      return acc;
    }, 0);
    console.log('exibiuComputado', teste);
    this.exibiuComputado = teste > 0;
    this.exibiuComputadoNao =
      x.reduce((acc, item) => {
        if (
          /*
          item.txHorario &&
          item.totalMinutosJornada !== 0 &&
          item.totalMinutosMarcados == 0*/
          !this.computadoPeloSigep(item)
        ) {
          acc++;
        }

        return acc;
      }, 0) > 0;

    this.totalMinutosJornada = x.reduce(
      (acc, item) => acc + item.totalMinutosJornada,
      0
    );
    this.totalGeralMinutosMarcados = x.reduce(
      (acc, item) => acc + this.minutosASeremMostrados(item),
      0
    );
    this.exibiuComprovanteNaoPDF =
      x.reduce((acc, item) => {
        if (item.listaMarcacao) {
          item.listaMarcacao.forEach((i) => {
            if (!i.idComprovante) {
              acc++;
            }
          });
        }
        return acc;
      }, 0) > 0;
    this.exibiuComprovantePDF =
      x.reduce((acc, item) => {
        if (item.listaMarcacao) {
          item.listaMarcacao.forEach((i) => {
            if (i.idComprovante) {
              acc++;
            }
          });
        }
        return acc;
      }, 0) > 0;
    /*
    this.exibiuCalculadoNao =
      x.reduce((acc, item) => {
        if (!item.calculado) {
          acc++;
        }
        return acc;
      }, 0) > 0;

    this.exibiuCalculadoSim =
      x.reduce((acc, item) => {
        if (item.calculado) {
          acc++;
        }
        return acc;
      }, 0) > 0;
*/
    this.exibiuCorte =
      x.reduce((acc, item) => {
        if (item.txMarcacoes?.includes('G')) {
          acc++;
        }
        return acc;
      }, 0) > 0;

    this.exibiuImpares =
      x.reduce(
        (acc, item) =>
          acc + (item.listaMarcacao ? item.listaMarcacao.length : 0),
        0
      ) %
        2 !==
      0;
    this.exibiuNaoHomologado =
      x.reduce((acc, item) => {
        if (item.listaMarcacaoWeb && item.listaMarcacaoWeb.length > 0) {
          acc++;
        }
        return acc;
      }, 0) > 0;
    this.carregando = false;
  }

  mostrarComprovante(id: number) {
    this.carregando = true;
    if (this.servidor) {
      this._sP.getComprovantePonto(id).subscribe((a: Comprovante) => {
        this.executarAoMostrarOuDownloadBlob(a.bbComprovante, false, '');
      });
    }
  }

  formatarHora(valor: number) {
    let negativo = valor < 0;

    let totalHoras = Math.floor((negativo ? valor * -1 : valor) / 60);
    let totalMinutos = (negativo ? valor * -1 : valor) % 60;

    let totalHorasH = totalHoras < 10 ? `0${totalHoras}` : `${totalHoras}`;
    let totalMinutosH =
      totalMinutos < 10 ? `0${totalMinutos}` : `${totalMinutos}`;

    return (negativo ? '-' : '') + totalHorasH + ':' + totalMinutosH;
  }

  public mostrar(mes: number, ano: number): void {
    this.carregando = true;
    this.mes = mes;
    this.ano = ano;
    this.dataSource = null;
    console.log('mostrar', this.meses, this.mes, this.ano);
    this.mesExtenso = this.meses[this.mes - 1] + '/' + this.ano;
    this._sP
      .getFrqMarcacao(this.servidor.nrMatricula, this.mes, this.ano)
      .subscribe({
        next: (x: Retorno) => {
          this.executarAoCarregarDatasource(x.resultado);
        },
        error: (e: any) => {
          this.handleError(e.message);
          return EMPTY;
        },
        complete: () => {
          this.carregando = false;
        },
      });
  }

  formatarData(d: Date) {
    return Util.dataMesAbrev(d);
  }

  handleError(e: string) {
    this.carregandoErros = true;
    this.carregando = false;
    this.erros$.next(true);
    this.erro = e;
    this._snack.abrirSnackBarErro(e);
  }
}
